exports.firebaseConfig = {
  apiKey: 'AIzaSyD9vUYZiIkVgxzAqbxFcGqoLi6XX3Gm2iI',
  authDomain: 'istockmgt-live.firebaseapp.com',
  projectId: 'istockmgt-live',
  storageBucket: 'istockmgt-live.appspot.com',
  messagingSenderId: '839483803516',
  appId: '1:839483803516:web:b6efa70eedad48a772c6f9',
  measurementId: 'G-XSJCJGQZ2M'
}
